module.exports = __webpack_public_path__ + "static/media/product_3.e52b5455.png";